module.exports = __webpack_public_path__ + "static/media/InternalPagesBanner_12-1800x250.6741f933.jpg";